export function uniqueNewRecords(existingRecords, incomingRecords) {
  const seenIds = new Set(
    Array.from(existingRecords, (record) => record.id).filter(Boolean)
  )

  return Array.from(incomingRecords).filter((record) => {
    if (!record.id) return true
    if (seenIds.has(record.id)) return false

    seenIds.add(record.id)
    return true
  })
}
